import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertHeight',
  standalone: false,
})
export class ConvertHeightPipe implements PipeTransform {
  transform(value: string): any {
    if (value) {
      value = value.replace(/\D/g, '');

      if (value.length > 3) {
        value = value.substring(0, 3);
      }

      switch (value.length) {
        case 2:
          value = value.replace(/(\d{1})(\d+)/, '$1.$2');
          break;
        case 3:
          value = value.replace(/(\d{1})(\d+)/, '$1.$2');
          break;
        default:
          return value;
      }
    }
    return value;
  }
}
